export default {
  "content": "<path d=\"M7.5 5h-2v15.5h11V16h2v4.5a2 2 0 01-2 2h-11a2 2 0 01-2-2V5a2 2 0 012-2h2v2z\" fill=\"#7B61FF\"/><path d=\"M20 2a3.5 3.5 0 013.5 3.5V8a3.5 3.5 0 01-3.5 3.5h-1.5v-2H20A1.5 1.5 0 0021.5 8V5.5A1.5 1.5 0 0020 4h-7a1.5 1.5 0 00-1.5 1.5V8A1.5 1.5 0 0013 9.5h1.086a2 2 0 011.414.586l2.707 2.707-1.414 1.414-2.707-2.707H13A3.5 3.5 0 019.5 8V5.5A3.5 3.5 0 0113 2h7z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};